const toExtra = (data) => {
    if (!Array.isArray(data))
        return [];
    return data.map((item) => {
        if (typeof item !== 'object' || item === null) {
            return {
                id: '',
                name: '',
                quantity: NaN,
                price: NaN,
                group: ''
            };
        }
        return {
            id: typeof item.id === 'string' ? item.id : '',
            name: typeof item.name === 'string' ? item.name : '',
            quantity: typeof item.quantity === 'number' && !isNaN(item.quantity)
                ? item.quantity
                : NaN,
            price: typeof item.price === 'number' && !isNaN(item.price) ? item.price : NaN,
            group: typeof item.group === 'string' ? item.group : ''
        };
    });
};
export { toExtra };
//# sourceMappingURL=extra.js.map